import {Vue, Component, Prop} from 'vue-property-decorator'

@Component
export class ItemsContent<T> extends Vue {
    @Prop({required: true}) items!: Array<T>
    @Prop({required: true}) isFullReload!: boolean
    @Prop({required: true}) isLoadNext!: boolean
    @Prop({required: true}) subscriptionError!: boolean
}